import "./Services.css"
import ServicesCard from "../components/servicesCard" 
function Services() {
  return (
    <div id="services" className="servicesPageContainer">
        <h1>
          Services 
        </h1>
        <div>
          <p style={{fontSize: "16pt", display:"inline-block"}}> We do it all! If the service you need isn't listed here,&nbsp;</p>
          <a href="/Contact" style={{fontSize: "16pt", display:"inline-block", borderBottom:"solid 1px", padding: "0px"}}> contact us</a>  
          <p style={{display:"inline-block", fontSize: "16pt"}}>&nbsp;and see if we can help!</p>
        </div>
        <div className="servicesContentContainer">
          <div className="servicesColumn">
            <ServicesCard filepath="assets/foundation repair.jpg" service="Foundation Repair"/>
            <ServicesCard filepath="assets/plumbing.jpg" service="Plumbing"/>
            <ServicesCard filepath="assets/commercial maintenance.jpg" service="Commercial Maintenance"/>
            <ServicesCard filepath="assets/concrete pads.jpg" service="Concrete Pads"/>
          </div>
          <div className="servicesColumn">
            <ServicesCard filepath="assets/room additions.jpg" service="Room Additions"/>
            <ServicesCard filepath="assets/kitchen and bathroom remodeling.jpg" service="Kitchen and Bathroom Remodeling"/>
            <ServicesCard filepath="assets/all types of flooring.jpg" service="All Types of Flooring"/>
            <ServicesCard filepath="assets/decks.jpg" service="Decks"/>
          </div>
          <div className="servicesColumn">
            <ServicesCard filepath="assets/drywall.jpg" service="Drywall"/>
            <ServicesCard filepath="assets/paint.jpg" service="Paint"/>
            <ServicesCard filepath="assets/roofing.jpg" service="Roofing"/>
            <ServicesCard filepath="assets/doors and windows.jpg" service="Doors and Windows"/>
          </div>

        </div>
    </div>
  )
}

export default Services